import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepSupportingDocuments.sectionTitle',
    defaultMessage: 'Section 9 - Supporting Documentation',
  },
  provideAll: {
    id: 'fastCover.stepSupportingDocuments.provideAll',
    defaultMessage: 'Provide all that are relevant to your claim',
  },
  yes: {
    id: 'fastCover.stepSupportingDocuments.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepSupportingDocuments.no',
    defaultMessage: 'No',
  },
  doYouHaveSupportingDocuments: {
    id: 'fastCover.stepSupportingDocuments.doYouHaveSupportingDocuments',
    defaultMessage:
      'Do you have supporting documents you would like to attach to this claim?',
  },
  attachSupportingDocuments: {
    id: 'fastCover.stepSupportingDocuments.attachSupportingDocuments',
    defaultMessage: 'Attach supporting documents',
  },
  upload: {
    id: 'fastCover.stepSupportingDocuments.upload',
    defaultMessage: 'Upload',
  },
  orDragFilesHere: {
    id: 'fastCover.stepSupportingDocuments.orDragFilesHere',
    defaultMessage: 'or drag files here',
  },
  weCanAssess: {
    id: 'fastCover.stepSupportingDocuments.weCanAssess',
    defaultMessage: 'We can assess claims quicker if we receive all the required documentation. Please review the list below and provide the documents that are relevant to your claim.',
  },
  DocDocument: {
    id: 'fastCover.stepSupportingDocuments.DocDocument',
    defaultMessage: 'Document',
  },
  DocRequired: {
    id: 'fastCover.stepSupportingDocuments.DocRequired',
    defaultMessage: 'Required',
  },
  DocUploaded: {
    id: 'fastCover.stepSupportingDocuments.DocUploaded',
    defaultMessage: 'Uploaded Document',
  },
  DocActions: {
    id: 'fastCover.stepSupportingDocuments.DocActions',
    defaultMessage: 'Actions',
  },
  UploadAny: {
    id: 'fastCover.stepSupportingDocuments.UploadAny',
    defaultMessage: 'Upload any additional documents that may help in resolving your claim faster',
  },
  SupportingDocs: {
    id: 'fastCover.stepSupportingDocuments.SupportingDocs',
    defaultMessage: 'Supporting Documents',
  },
  warningMissingRequiredDocument: {
    id: 'fastCover.stepSupportingDocuments.warningMissingRequiredDocument',
    defaultMessage: 'Warning – Missing Required Documents!',
  },
  warningMissingRequiredDocumentText1: {
    id: 'fastCover.stepSupportingDocuments.warningMissingRequiredDocumentText1',
    defaultMessage: 'You have not attached Required Documents that are mandatory for processing of this claim. You may still proceed to next steps of this claim, however please be sure to return to this page and attach all Required Documents. You can save this claim as a draft and return anytime within 30 days of commencement to attach all Required Documents.',
  },
  warningInvalidRequiredDocument: {
    id: 'fastCover.stepSupportingDocuments.warningInvalidRequiredDocument',
    defaultMessage: 'Warning - Invalid Documents',
  },
  warningInvalidRequiredDocumentText1: {
    id: 'fastCover.stepSupportingDocuments.warningInvalidRequiredDocumentText1',
    defaultMessage: 'One or more sections that you have uploaded files against have either failed the validation or have not been validated. If you have fixed data since the initial validation result, click the ‘Check Again’ button to refresh the result. Proceeding without fixing the issues may delay the outcome of your claim.',
  },
  wouldYouLikeToProceedToNextSteps: {
    id: 'fastCover.stepSupportingDocuments.wouldYouLikeToProceedToNextSteps',
    defaultMessage: 'Would you like to proceed to next steps',
  },
  InitialDocumentReview: {
    id: 'fastCover.stepSupportingDocuments.InitialDocumentReview',
    defaultMessage: 'Validation Message',
  },
  youHaveNotAttachedAnyRequiredDocumentsForYourClaimSCTI: {
    id: 'fastCover.stepSupportingDocuments.youHaveNotAttachedAnyRequiredDocumentsForYourClaimSCTI',
    defaultMessage: 'You have not attached any required documents for your claim.',
  },
  warningMissingRequiredDocumentDetailsSCTI: {
    id: 'fastCover.stepSupportingDocuments.warningMissingRequiredDocumentDetailsSCTI',
    defaultMessage: 'You may still proceed with your claim submission, however, please be aware that there may be a delay in processing your claim if we need to contact you to obtain supporting documents to help us make a decision on your claim.',
  },
  youMayAlsoSaveThisClaimAsADraftAndReturnAnytimeWithin30DaysOfCommencementToAttachTheRequiredDocumentsSCTI: {
    id: 'fastCover.stepSupportingDocuments.youHaveNotAttachedAnyRequiredDocumentsForYourClaimSCTI',
    defaultMessage: 'You may also save this claim as a draft and return anytime within 30 days of commencement to attach the required documents.',
  },
  wouldYouLikeToProceedToNextStepsSCTI: {
    id: 'fastCover.stepSupportingDocuments.wouldYouLikeToProceedToNextStepsSCTI',
    defaultMessage: 'Would you like to proceed to the next step without providing the required documents?',
  },
  provideAllRelevantToClaim: {
    id: 'fastCover.stepSupportingDocuments.provideAllRelevantToClaim',
    defaultMessage: 'Provide all that are relevant to your claim.',
  },
  claimTypeDocumentsHeader: {
    id: 'fastCover.stepSupportingDocuments.claimTypeDocumentsHeader',
    defaultMessage: '{claimTypeDescription} documents',
  },
  provincialHealthCoverageDocDescription: {
    id: 'fastCover.stepSupportingDocuments.provincialHealthCoverageDocDescription',
    defaultMessage: 'Please complete, sign and upload the provincial health form that you downloaded in previous step.',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/messages.js